import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../services/maintenanceService';
import { ENTER } from '@angular/cdk/keycodes';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedAuthService } from '../../../../shared/shared.auth.service';

@Component({
    selector: 'app-enable-field-popup',
    templateUrl: './enable-field-popup.component.html',
    styleUrl: './enable-field-popup.component.css',
    standalone: false
})
export class EnableFieldPopupComponent {
  @Input() clearFormFields: boolean = false;
  @Input() initiativeId: any;
  @Input() fieldData: any;
  @Input() categories: any;
  @Output() emitReqPayload: EventEmitter<any> = new EventEmitter();
  newCategoryClicked = false;
  newSubCategoryClicked = false;
  disableAddCategory: boolean = true;
  disableAddSubCategory: boolean = true;
  fieldType: any;
  fieldTypeOptions: any = [];
  columnName: any;
  limitExceedColName: boolean = false;
  inputType: any;
  categoryDefaultState: any;
  inputTypeOptions: any = ['dropdown', 'date picker', 'input', 'multi_dropdown', 'radio button'];
  dataType: any
  disableDataType = false;
  dataTypeOptions: any = ['String', 'float', 'int', 'date'];
  length: any;
  allowedValues: string[] = [];
  newAllowedValues: string = '';
  selectable = true;
  removable = true;
  addOnBlur = true;
  isColNameExst: boolean = false;
  readonly separatorKeysCodes: number[] = [ENTER];
  editable: any;
  visible: any;
  bulkRequired: any;
  editRoles: any = [];
  category: any;
  subCategory: any;
  category_default_state: any;
  viewRole: any;
  viewRoleOptions: any = ['None', 'All'];
  description: any;
  limitExceedDesc: boolean = false;
  modifyUI: any;
  isSystemAdmin: any = false;
  isAdmin: any = false;
  isValid: boolean = true;
  showLoader: boolean = false;
  @Input() currentFieldData: any;
  @Input() isEdit: boolean = false;
  selectedRoles: Array<any> = [];
  @Input() columns: Array<any>;
  editableObj: any = {};
  isDataUpdated: boolean = false;
  payLoadForEdit: any;
  @Input() editRolesOptions = [];
  usedKeyWords: Array<any> = [];
  disableAllowedValues = false;
  fieldsAreFullError = '';
  subCategoryOptions: string[] = [];
  @Input() isVisibleFieldDisabled: boolean = false;
  AddCategoryDataUpdated = {
    "category": '',
    "subCategory": '',
    "categoryDefaultState": ''
  };
  disableAddCategoryState: boolean;
  @ViewChild('form') form:any // To reset the form after submission

  constructor(
    public toaster: ToastrService,
    public maintenanceService: MaintenanceService,
    private sanitizer: DomSanitizer,
  private sharedAuthService : SharedAuthService) { }

  ngOnInit() {
    this.initializeCategoryData();
    this.isSystemAdmin = this.sharedAuthService.checkForRoleAccess('System Admin');
    this.isAdmin = this.sharedAuthService.checkForRoleAccess('Admin'); 
  }

  ngOnChanges() {
    this.initializeBasicFields();
    
    if (this.isAdmin || this.isSystemAdmin) {
      this.configureFieldTypeOptions();
    }

    this.setDefaultValues();

    if (this.isEdit) {
      this.populateEditFields();
    }

    this.fieldValueChanges();
  }

  private initializeBasicFields(): void {
    if (!this.allowedValues) this.allowedValues = [];
    if (this.clearFormFields) this.clearFields();
    this.initializeCategoryData();
    this.initializeSubCategoryData();
  }

  private configureFieldTypeOptions(): void {
    const fieldCounts = this.calculateFieldTypeCounts();
    
    this.fieldTypeOptions = [];
    this.fieldsAreFullError = '';

    if (this.isSystemAdmin) {
      this.addSystemAdminFieldTypeOptions(fieldCounts);
    } else if (this.isAdmin) {
      this.addAdminFieldTypeOptions(fieldCounts);
    }
  }

  private calculateFieldTypeCounts(): { initiative: number; calc: number; generic: number } {
    let initiative_count = 0;
    let calc_count = 0;
    let generic_count = 0;

    this.fieldData.filter(val => {
      val.tableData.filter(x => {
        if (x.Field_Type == 'Initiative') initiative_count++;
        else if (x.Field_Type == 'Calc_initiative') calc_count++;
        else if (x.Field_Type == 'Generic') generic_count++;
      });
    });

    return { initiative: initiative_count, calc: calc_count, generic: generic_count };
  }

  private addSystemAdminFieldTypeOptions(counts: { initiative: number; calc: number; generic: number }): void {
    if (counts.initiative < 50) {
      this.fieldTypeOptions.push('Initiative');
    } else {
      this.fieldsAreFullError += 'Initiative Fields are full. ';
    }

    if (counts.calc < 10) {
      this.fieldTypeOptions.push('Calc_initiative');
    } else {
      this.fieldsAreFullError += 'Calc_initiative Fields are full. ';
    }

    if (counts.generic < 50) {
      this.fieldTypeOptions.push('Generic');
    } else {
      this.fieldsAreFullError += 'Generic Fields are full. ';
    }
  }

  private addAdminFieldTypeOptions(counts: { initiative: number; calc: number; generic: number }): void {
    if (counts.initiative < 50) {
      this.fieldTypeOptions.push('Initiative');
    } else {
      this.fieldsAreFullError += 'Initiative Fields are full. ';
    }
    this.fieldType = 'Initiative';
  }

  private setDefaultValues(): void {
    this.length = 300;
    this.viewRole = 'All';
  }

  private populateEditFields(): void {
    this.isDataUpdated = false;
    const currentfieldData = _.cloneDeep(this.currentFieldData);
    
    this.getEditableColumns();
    this.populateBasicEditFields(currentfieldData);
    this.populateCategoryFields(currentfieldData);
    this.populateRoleFields(currentfieldData);
    
    if (this.fieldType == 'Initiative') {
      this.checkForAllowedValues();
    }
  }

  private populateBasicEditFields(data: any): void {
    this.columnName = data.column_name;
    this.inputType = data.input_type == "NA" ? '' : data.input_type;
    this.dataType = data.data_type == "NA" ? '' : data.data_type;
    this.length = data.length;
    this.editable = data.Editable;
    this.visible = data.Visible;
    this.bulkRequired = data.Bulk_required;
    this.modifyUI = data.Modify_UI;
    this.allowedValues = data.allowed_values == "NA" ? [] : data.allowed_values;
    this.fieldType = data.Field_Type;
    this.description = data.Description ? data.Description : '';
  }

  private populateCategoryFields(data: any): void {
    this.AddCategoryDataUpdated.category = data.category;
    this.category = data.category;
    this.subCategory = data.SubCategory ?? data.sub_category ?? '';
    this.AddCategoryDataUpdated.subCategory = this.subCategory;
    this.AddCategoryDataUpdated.categoryDefaultState = data.category_default_state;
    this.category_default_state = data.category_default_state;
  }

  private populateRoleFields(data: any): void {
    this.editRoles = data.Edit_Roles == "NA" ? '' : data.Edit_Roles;
    this.viewRole = data.View_Role == "NA" ? '' : data.View_Role;
  }

  initializeCategoryData() {
    this.categoryDefaultState = ['Expand', 'Collapse'];
  }

  initializeSubCategoryData() {
    this.subCategoryOptions = [];
    if (this.fieldData && this.fieldData.length > 0) {
      const subCategories: string[] = this.fieldData
        .flatMap(field => field?.tableData || [])
        .map(row => row?.SubCategory ?? row?.sub_category)
        .filter((value): value is string => typeof value === 'string' && value.trim().length > 0);
      this.subCategoryOptions = [...new Set(subCategories)];
    }
  }

  sanitizeInput(input: string) {
    return this.sanitizer.bypassSecurityTrustHtml(input);
  }

  clearFields() {
    this.fieldType = '';
    this.columnName = '';
    this.limitExceedColName = false;
    this.inputType = '';
    this.dataType = '';
    if (this.isSystemAdmin) {
      this.length = '';
    } else {
      this.length = 300;
    }
    this.allowedValues = [];
    this.newAllowedValues = '';
    this.editable = '';
    this.visible = '';
    this.bulkRequired = '';
    this.category = '';
    this.subCategory = '';
    this.category_default_state = '';
    this.editRoles = [];
    // this.editRolesOptions = [];
    this.viewRole = ''
    this.description = '';
    this.clearFormFields = false;
    this.editableObj = {};
    this.isDataUpdated = false;
    this.payLoadForEdit = null;
    this.isColNameExst = false;
    this.modifyUI = '';
    this.newCategoryClicked = false; // Reset the new category button state
    this.newSubCategoryClicked = false;
    if(this.form && this.form.nativeElement) // Check if form is defined before resetting
      this.form.nativeElement.reset(); // Reset the form to clear all fields
    this.AddCategoryDataUpdated.category = '';
    this.AddCategoryDataUpdated.subCategory = '';
    this.AddCategoryDataUpdated.categoryDefaultState = '';
  }

  focusColName() {
    if (this.columnName?.length <= 50) {
      this.limitExceedColName = false;
    }
    if (this.columnName?.length >= 50) {
      this.limitExceedColName = true;
    }
    else
      this.limitExceedColName = false;
  }

  focusDes() {
    if (this.description?.length <= 3000) {
      this.limitExceedDesc = false;
    }
    if (this.description?.length >= 3000) {
      this.limitExceedDesc = true;
    }
    else
      this.limitExceedDesc = false;
  }


  onSubmit(form) {
    if (!this.validateForm(form)) {
      return;
    }
  
    if (this.isEdit) {
      this.handleEditSubmission();
    } else {
      this.handleCreateSubmission();
    }
  }
  
  private validateForm(form: any): boolean {
    if (this.inputType === 'radio button' && this.allowedValues.length !== 2) {
      this.toaster.error(
        "Radio Button must have 2 values.", 
        '', 
        { positionClass: 'toast-top-center', timeOut: 3000 }
      );
      return false;
    }
  
    if (!form.valid) {
      this.toaster.error(
        "Please fill all required fields!", 
        '', 
        { timeOut: 10000, positionClass: 'toast-top-center' }
      );
      return false;
    }
  
    if (this.isColNameExst) {
      this.toaster.error(
        "Column name already exists!", 
        '', 
        { timeOut: 10000, positionClass: 'toast-top-center' }
      );
      return false;
    }
  
    return true;
  }
  
  private handleEditSubmission(): void {
    if (this.payLoadForEdit.category_default_state) {
      this.payLoadForEdit.category = this.AddCategoryDataUpdated.category;
    }
    this.emitReqPayload.emit(this.payLoadForEdit);
  }
  
  private handleCreateSubmission(): void {
    const reqPayload = this.buildCreatePayload();
    this.clearFields();
    this.emitReqPayload.emit(reqPayload);
  }
  
  private buildCreatePayload(): any {
    return {
      "Field_Type": this.getValueOrDefault(this.fieldType),
      "initiative_ID": this.initiativeId,
      "column_name": this.getValueOrDefault(this.columnName),
      "Description": this.description?.length ? this.description : null,
      "input_type": this.getValueOrDefault(this.inputType),
      "data_type": this.getValueOrDefault(this.dataType),
      "length": Number(this.length) || 0,
      "allowed_Values": this.getAllowedValuesString(),
      "Editable": this.getYesNoValue(this.editable),
      "Visible": this.getYesNoValue(this.visible),
      "Bulk_required": this.getYesNoValue(this.bulkRequired),
      "Edit_Roles": this.getEditRolesString(),
      "category": this.getValueOrDefault(this.category),
      "SubCategory": this.getValueOrDefault(this.subCategory),
      "category_default_state": this.getValueOrDefault(this.category_default_state),
      "View_Role": this.viewRole?.length ? this.viewRole : 'NA',
      ...(this.isSystemAdmin ? { "Modify_UI": this.getYesNoValue(this.modifyUI) } : {})
    };
  }
  
  private getValueOrDefault(value: any): string {
    return (value && value.length) ? value : 'NA';
  }
  
  private getYesNoValue(value: any): string {
    return (value && value === 'Yes') ? 'Yes' : 'No';
  }
  
  private getAllowedValuesString(): string {
    return (this.allowedValues && this.allowedValues.length) 
      ? this.allowedValues.join(',') 
      : 'NA';
  }
  
  private getEditRolesString(): string {
    return (this.editRoles && this.editRoles.length) 
      ? this.editRoles.join(',') 
      : 'NA';
  }


  add(event): void {
    const input = event.input;
    const value = event.value;
    if (this.allowedValues == undefined) this.allowedValues = [];
    if (this.allowedValues?.indexOf(value) != -1) {
      this.toaster.error("Value already exists.", '', { positionClass: 'toast-top-center', timeOut: 3000, });
    }
    else if (this.inputType == 'radio button' && this.allowedValues?.length >= 2) {
      this.toaster.error("Radio Button can only have 2 values.", '', { positionClass: 'toast-top-center', timeOut: 3000, });
    }
    else if ((value || '').trim()) {
      this.allowedValues.push(value);
    }
    if (input) {
      input.value = '';
    }
    this.fieldValueChanges();
  }

  remove(chip) {
    if (this.disableAllowedValues) {
      this.toaster.error("Cannot delete this field.", '', { positionClass: 'toast-top-center', timeOut: 3000, });
      return;
    }
    const index = this.usedKeyWords.indexOf(chip);
    if (index >= 0) {
      this.toaster.error("Unable to delete. This field is already referenced.", '', { positionClass: 'toast-top-center', timeOut: 3000, });
      return false;
    } else {
      const idx = this.allowedValues.indexOf(chip);
      this.allowedValues.splice(idx, 1);
    }
    this.fieldValueChanges();
  }

  newCategory() {
    this.newCategoryClicked = !this.newCategoryClicked;
    this.AddCategoryDataUpdated.category = '';
    this.disableApplyAddCategory();
  }

  newSubCategory() {
    this.newSubCategoryClicked = !this.newSubCategoryClicked;
    this.AddCategoryDataUpdated.subCategory = '';
    this.disableApplyAddSubCategory();
  }

  categoryChange(ct) {
    this.AddCategoryDataUpdated.category = ct.value;
    this.setDefaultState(ct.value);
    this.disableApplyAddCategory();
  }

  subCategoryChange(subCategory) {
    this.AddCategoryDataUpdated.subCategory = subCategory.value;
    this.disableApplyAddSubCategory();
  }

  setDefaultState(value) {
    const filteredCategory = this.categories.filter((cat) => cat.categoryName === value);
    if(filteredCategory && filteredCategory.length > 0) {
      const ct = {
        value: filteredCategory[0].defaultState ? filteredCategory[0].defaultState : 'Collapse'
      } 
      this.categoryDefaultStateChange(ct);
    }
  }

  categoryDefaultStateChange(ct) {
    this.AddCategoryDataUpdated.categoryDefaultState = ct.value;
    this.disableApplyAddCategoryState();
  }

  disableApplyAddCategoryState() {
    if (this.AddCategoryDataUpdated.categoryDefaultState) {
      this.category_default_state = this.AddCategoryDataUpdated.categoryDefaultState;
      this.disableAddCategoryState = false;
      this.isDataUpdated = true;
      if (this.isEdit) {
        this.checkisDataUpdated();
      }
    }
    else {
      this.disableAddCategoryState = true;
    }
  }

  disableApplyAddCategory() {
    if (this.AddCategoryDataUpdated.category) {
      this.category = this.AddCategoryDataUpdated.category;
      this.disableAddCategory = false;
      this.isDataUpdated = true;
      if (this.isEdit) {
        this.checkisDataUpdated();
      }
    }
    else {
      this.disableAddCategory = true;
    }
  }

  disableApplyAddSubCategory() {
    if (this.AddCategoryDataUpdated.subCategory) {
      this.subCategory = this.AddCategoryDataUpdated.subCategory;
      this.disableAddSubCategory = false;
      this.isDataUpdated = true;
      if (this.isEdit) {
        this.checkisDataUpdated();
      }
    }
    else {
      this.disableAddSubCategory = true;
    }
  }

  getEditableColumns() {
    const obj = {};
    this.columns.forEach((val) => {
      if (this.isSystemAdmin)
        obj[val.key] = val.isSystemAdminEdit;
      else if (this.isAdmin)
        obj[val.key] = val.isAdminEdit;
    });
    this.editableObj = obj;
  }

  checkisDataUpdated() {
    const payloadForEdit = this.initializePayloadForEdit();
    let isUpdated = false;

    // Check basic field updates
    isUpdated = this.checkBasicFieldUpdates(payloadForEdit) || isUpdated;
    
    // Check complex field updates (those with 'NA' handling)
    isUpdated = this.checkComplexFieldUpdates(payloadForEdit) || isUpdated;
    
    // Check array field updates
    isUpdated = this.checkArrayFieldUpdates(payloadForEdit) || isUpdated;

    this.finalizePayload(payloadForEdit, isUpdated);
  }

  private initializePayloadForEdit(): any {
    return {
      initiative_ID: this.initiativeId,
      column_ID: this.currentFieldData.column_id,
      Type: this.currentFieldData.Field_Type
    };
  }

  private checkBasicFieldUpdates(payload: any): boolean {
    let isUpdated = false;
    
    const basicFields = [
      { key: 'column_name', current: this.columnName },
      { key: 'length', current: this.length },
      { key: 'Editable', current: this.editable },
      { key: 'Visible', current: this.visible },
      { key: 'Bulk_required', current: this.bulkRequired },
      { key: 'Modify_UI', current: this.modifyUI },
      { key: 'Field_Type', current: this.fieldType },
      { key: 'Description', current: this.description }
    ];

    for (const field of basicFields) {
      if (this.isFieldUpdated(field.key, field.current, this.currentFieldData[field.key])) {
        payload[field.key] = field.current;
        isUpdated = true;
      }
    }

    return isUpdated;
  }

  private checkComplexFieldUpdates(payload: any): boolean {
    let isUpdated = false;
    
    const complexFields = [
      { key: 'input_type', current: this.inputType },
      { key: 'data_type', current: this.dataType },
      { key: 'View_Role', current: this.viewRole },
      { key: 'category', current: this.category },
      { key: 'SubCategory', current: this.subCategory },
      { key: 'category_default_state', current: this.category_default_state }
    ];

    for (const field of complexFields) {
      if (this.isComplexFieldUpdated(field.key, field.current, this.currentFieldData[field.key])) {
        payload[field.key] = field.current;
        isUpdated = true;
      }
    }

    return isUpdated;
  }

  private checkArrayFieldUpdates(payload: any): boolean {
    let isUpdated = false;

    // Check allowed values
    if (this.isAllowedValuesUpdated()) {
      const allowedValuesString = this.getAllowedValuesString();
      payload['allowed_Values'] = allowedValuesString;
      isUpdated = true;
    }

    // Check edit roles
    if (this.isEditRolesUpdated()) {
      const editRolesString = this.getEditRolesString();
      payload['Edit_Roles'] = editRolesString;
      isUpdated = true;
    }

    return isUpdated;
  }

  private isFieldUpdated(fieldKey: string, currentValue: any, originalValue: any): boolean {
    return this.editableObj[fieldKey] && currentValue !== originalValue;
  }

  private isComplexFieldUpdated(fieldKey: string, currentValue: any, originalValue: any): boolean {
    if (!this.editableObj[fieldKey]) return false;

    const isOriginalNA = originalValue === 'NA';
    const isCurrentEmpty = currentValue === '' || currentValue == null;

    if (isOriginalNA && !isCurrentEmpty) {
      return true;
    }

    if (!isOriginalNA && originalValue !== currentValue) {
      return true;
    }

    return false;
  }

  private isAllowedValuesUpdated(): boolean {
    if (!this.editableObj['allowed_values']) return false;

    const currentAllowedValues = this.getSortedAllowedValues();
    const originalAllowedValues = this.getOriginalAllowedValues();

    if (this.currentFieldData.allowed_values === 'NA') {
      return this.allowedValues.length > 0;
    }

    return originalAllowedValues !== currentAllowedValues;
  }

  private isEditRolesUpdated(): boolean {
    if (!this.editableObj['Edit_Roles']) return false;

    const currentEditRoles = this.getSortedEditRoles();
    const originalEditRoles = this.getOriginalEditRoles();

    if (this.currentFieldData.Edit_Roles === 'NA') {
      return this.editRoles.length > 0;
    }

    return originalEditRoles !== currentEditRoles;
  }

  private getSortedAllowedValues(): string {
    return this.allowedValues.length > 0 
      ? this.allowedValues.sort((a, b) => a.localeCompare(b)).join(',') 
      : '';
  }

  private getOriginalAllowedValues(): string {
    return this.currentFieldData.allowed_values !== 'NA' 
      ? this.currentFieldData.allowed_values.sort((a, b) => a.localeCompare(b)).join(',')
      : '';
  }

  private getSortedEditRoles(): string {
    return this.editRoles.length > 0 
      ? this.editRoles.sort().join(',') 
      : '';
  }

  private getOriginalEditRoles(): string {
    return this.currentFieldData.Edit_Roles !== 'NA' 
      ? this.currentFieldData.Edit_Roles.sort().join(',')
      : '';
  }

  private finalizePayload(payload: any, isUpdated: boolean): void {
    this.payLoadForEdit = payload;
    this.isDataUpdated = isUpdated;
  }

  fieldValueChanges(field: string = '') {
    switch (field) {
      case 'visible':
        this.checkVisibleValue();
        break;
      case 'columnName':
        this.checkForColumnNameExist();
        this.focusColName();
        break;
    }
    this.checkToSetDefaultValues();
    if (this.isEdit) {
      this.checkisDataUpdated();
    }
  }
  checkToSetDefaultValues() {
    if (this.inputType == 'input' || this.inputType == 'date picker') {
      this.allowedValues = ['Any'];
      this.disableAllowedValues = true;
    } else {
      this.allowedValues = !this.allowedValues ? [] : this.allowedValues;
      this.disableAllowedValues = false;
    }
    if (this.inputType == 'date picker') {
      this.dataType = 'date';
      this.disableDataType = true;
    } else if (this.inputType != 'input') {
      this.dataType = 'String';
      this.disableDataType = true;
    } else {
      this.disableDataType = false;
    }
    if (this.inputType == 'radio button' && this.allowedValues.length > 2) {
      this.allowedValues = [];
    }

  }
  checkVisibleValue() {
    if (this.visible == 'No') {
      this.bulkRequired = 'No';
      this.editable = 'No';
    }
  }



  checkForColumnNameExist() {
    this.isColNameExst = false;
    if (this.fieldData && this.fieldData.length) {
      for (const field of this.fieldData) {
        for (const table of field.tableData) {
          if (this.isEdit) {
            if (this.columnName.toLowerCase() != this.currentFieldData.column_name.toLowerCase() && table.column_name.toLowerCase() == this.columnName.toLowerCase()) {
              this.isColNameExst = true;
            }
          } else {
            if (table.column_name.toLowerCase() == this.columnName.toLowerCase()) {
              this.isColNameExst = true;
            }
          }
        }
      }
    }
  }
  checkForAllowedValues() {
    const payload = {
      columnID: this.currentFieldData.column_id,
      initiativeID: this.initiativeId
    }
    this.usedKeyWords = [];
    this.maintenanceService.getAllUsedWords(payload).subscribe((res) => {
      if (res && res.length > 0) {
        if (this.allowedValues.length > 0) {
          const allowedValue = this.allowedValues.map(val => val.toLowerCase());
          this.usedKeyWords = res.filter(element => {
            if (allowedValue.indexOf(element.toLowerCase()) != -1) {
              return element;
            }
          });
        }
      }
    }, (error) => {
      console.error(error);
      this.showLoader = false;
      this.toaster.error("Unable to fetch data.", '', { positionClass: 'toast-top-center', timeOut: 1000, })
      if (error.status === 404) {
        this.toaster.error("Data not found.", '', { positionClass: 'toast-top-center', timeOut: 3000 });
      } else {
        this.toaster.error("Unable to fetch data.", '', { positionClass: 'toast-top-center', timeOut: 1000, })
      }
    });
  }
}
